import React from 'react';

import styled from 'styled-components';

import { TabTableHeaderI } from 'interfaces/content-stack/modular-blocks/tabTable';
import { ContentAlignmentType } from 'interfaces/styles';

const HeaderRow = styled.div<{ $columns: number }>`
  grid-template-columns: repeat(${(props) => props.$columns}, 1fr);
  grid-auto-columns: 1fr;
  display: grid;

  @media screen and (max-width: ${(props) => props.theme.breakpoints.xs}) {
    min-width: calc(${(props) => props.$columns} * 6rem);
  }
`;

const HeaderCell = styled.div<{
  $redBackground: boolean;
  $alignment: ContentAlignmentType;
  $mobileStyle: string;
  $width: number;
}>`
  ${(props) =>
    props.$redBackground
      ? `
      background: ${props.theme.colors.primaryRed};
      color: ${props.theme.colors.white};
`
      : `
      background: transparent;
      color: ${props.theme.colors.black};
  `}
  text-transform: uppercase;
  align-items: center;
  padding: 0.75rem 0.5rem;
  ${(props) => props.$alignment === 'left' && `padding: 0.75rem 1rem 0.75rem 0rem;`}
  display: flex;
  font-family: ${(props) => props.theme.fonts.default};
  font-size: 0.75rem;
  font-weight: 600;
  justify-content: ${(props) => (props.$alignment ? `${props.$alignment}` : 'right')};
  text-align: ${(props) => (props.$alignment ? `${props.$alignment}` : 'right')};
  vertical-align: top;
  height: 3rem;

  @media screen and (max-width: ${(props) => props.theme.breakpoints.lg}) {
    padding: 0.5rem;
    ${(props) =>
      props.$alignment === 'left' &&
      `
      padding-left: 1.5rem;
      padding-right: 1rem;
    `}
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 0.66rem;
    line-height: 1.2;
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.xs}) {
    ${(props) =>
      props.$alignment === 'left'
        ? `
        padding-left: 0.75rem;
        padding-right: 0.75rem;`
        : `
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    `};
  }

  ${(props) => props.$width ?? `width: ${props.$width}%;`}

  ${(props) =>
    props.$mobileStyle === 'Standard Table'
      ? 'font-size: 1.125rem;'
      : props.$mobileStyle === 'Comparison Row' && 'font-size: 1rem;'}
`;

interface TabTableHeaderProps {
  headers: TabTableHeaderI[];
  mobileStyle: string;
}

function TabTableHeader({ headers, mobileStyle }: TabTableHeaderProps) {
  return (
    <HeaderRow $columns={headers.length}>
      {headers.map((header, index) => {
        const { content, headerAlignment, headerWidth, redBackground } = header;

        return (
          <HeaderCell
            key={index}
            $alignment={headerAlignment}
            $mobileStyle={mobileStyle}
            $redBackground={redBackground}
            $width={headerWidth}
          >
            <div>{content}</div>
          </HeaderCell>
        );
      })}
    </HeaderRow>
  );
}

export default React.memo(TabTableHeader);
